import TransUnionView from './TransUnionView';

export default TransUnionView;
